// Styles
import './index.css';

// Core
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { $state, $stateParams } from '../../router';

// Redux
import { connect } from 'react-redux';
import {
    updateContact,
    updateEventAttendance,
    replaceSessions,
    replaceEvents
} from '../../redux/actions';

// Components
import ProfileQr from './qr/qr.jsx';
import StatusControl from './StatusControl';
import RSVP_CONSTS from '../../constants';
import {
    GeckoRow,
    GeckoCol,
    GeckoDialogService,
    GeckoToastService,
    GeckoIcon,
    GeckoBtn,
    GeckoModalService,
    GeckoModal
} from '@geckolabs/gecko-react-ui';

// Services
import RsvpService from '../../services/RsvpService';
import WebinarService from '../../services/Webinar';

import Utils from '../../services/utils/utils';
import { __, STR_KEY } from '../../services/Translate';
import DateUtils from '../../services/DateUtils';

export class Profile extends Component {

    rsvpService = new RsvpService();

    componentDidMount() {
        let event = this.props.events[0];
    }

    changeField = ({ value }) => {
        new GeckoDialogService().confirm(__(STR_KEY.PROFILE_DIALOG_GUEST_CHANGE)).then(confirm => {
            if (confirm) {
                this.rsvpService.changeGuests(this.props.eventAttendance.id, value).then(response => {

                    let data = this.rsvpService.parseRsvp(response);

                    this.props.updateStore(data);

                    new GeckoToastService().success(__(STR_KEY.PROFILE_TOAST_GUEST_CHANGE));

                }).catch(error => new GeckoToastService().error(error));
            }
        })

    }

    /**
     * Renders the perforated UI element on the main event card
     */
    renderSeparator() {
        return (
            <div className=" flex-row d-flex profileSeparator">
                <div className="leftRip">
                    <img className="shadowRip" src="./images/semi-circle.svg" width="20" height="40" alt="" />
                </div>

                <div className="inner"><div className="dash"></div></div>

                <div className="rightRip">
                    <img className="shadowRip" src="./images/semi-circle.svg" width="20" height="40" alt="" />
                </div>
            </div>
        )
    }

    renderGuestCount() {
        if (this.props.event && this.props.event.attendance && this.props.event.attendance.attendances_count && this.props.event.attendance.attendances_count > 1) {

            // Minus 1 (the invitee) to get the guest count
            const guest_count = this.props.event.attendance.attendances_count - 1;
            const guest_str = (guest_count > 1 ? __(STR_KEY.PROFILE_GUESTS) : __(STR_KEY.PROFILE_GUEST));

            return (
                <GeckoRow>
                    <GeckoCol width="12">
                        <div className="guestCount text-center">
                            +{guest_count} {guest_str}
                        </div>
                    </GeckoCol>
                </GeckoRow>
            )
        }

        return null;
    }

    isBooked() {
        if (!this.props.eventAttendance.event_id) {
            return false;
        }

        const state_attendance = this.props.eventAttendance;

        if (state_attendance.status === RSVP_CONSTS.ATTENDANCE.STATUS_CANCELLED || state_attendance.status === RSVP_CONSTS.ATTENDANCE.STATUS_REMOVED) {
            return false;
        }

        return true;
    }

    openWebinarUrl() {
        const event         = this.props.event;
        const url           = event.webinar_url;
        const description   = event.webinar_description;
        const isOnline      = RsvpService.isOnline(event);
        const hasPassed     = RsvpService.hasEventPassed(event);
        WebinarService.openModal(url, description, isOnline, hasPassed);
    }

    updateCheckin(going = false) {
        const event = this.props.event;
        // Navigate to stream page (when video_uuid is set on event)
        if (RsvpService.isOnline(event) && event.video_uuid) {
            return RsvpService.goToStreamPage(event.id);
        } else {
            try {
                const eventId = event.id;
                const attend = (going ? 'yes' : 'no');

                this.rsvpService.updateCheckin(eventId, attend).then((rsvpData) => {
                    new GeckoToastService().success(__(STR_KEY.PROFILE_TOAST_CHECKED_IN));
                    $state.go($state.$current.name, $stateParams, { reload: true });
                    // Open webinar url
                    this.openWebinarUrl();
                }).catch(err => new GeckoToastService().error(err));
                return;
            }
            catch (err) {
                console.log(err);
            }
        }
    }

    renderStatusControl() {
        const event = this.props.events[0];

        // Dont show when event is ONLINE session event
        if (!RsvpService.isSingleEvent(event)) return null;

        return (
            <StatusControl 
                event={event} 
                checkinHandler={() => this.updateCheckin(true)}
             />
        );
    }

    renderEventAttendanceStatus() {
        const status = __(`status.${this.props.events[0].attendance.status}`);
        if (this.props.event && this.props.event.attendance) {
            return (
                <div className="row justify-content-center eventStatus">
                    <div className="eventStatusIcon">
                        <GeckoIcon icon={RSVP_CONSTS.ATTENDANCE.ICONS[this.props.event.attendance.status]}/>
                    </div>
                    <p className="eventStatusText">{status}</p>
                </div>
            );
        }
        return null;
    }

    mapsSelector() {
        if /* if we're on iOS, open in Apple Maps */
            (this.props.location[0] &&
            (navigator.platform.indexOf("iPhone") !== -1) ||
            (navigator.platform.indexOf("iPod") !== -1) ||
            (navigator.platform.indexOf("iPad") !== -1)) {
            return window.open(`maps://maps.google.com/maps?saddr=My+Location&daddr=${this.props.location[0].lat},${this.props.location[0].lng}&amp;ll=`);
        }

        else if (this.props.location[0]) /* else use Google */ {
            return window.open(`https://maps.google.com/maps?saddr=My+Location&daddr=${this.props.location[0].lat},${this.props.location[0].lng}&amp;ll=`);
        }
        else return false;
    }

    renderDeliveryMethod() {
        const [str, icon] = RsvpService.getPrettyDeliveryMethod(this.props.event);

        return (
            <div className="row profileMetaFieldContainer">
                <GeckoCol width="12">
                    <div className="profileMetaIcon">
                        <i className={icon} style={{fontSize: '19px'}}></i>
                    </div>
                    <div className="profileMetaDetails">
                        <div className="profileMetaField eventLocation">
                            {str}
                        </div>
                    </div>
                </GeckoCol>
            </div>
        );
    }

    renderLocation() {

        if (!this.props.event.location_title_legacy && !this.props.location[0] || RsvpService.isOnline(this.props.event)) {
            return null;
        }

        let clickableClass = this.props.location[0] ? 'clickable' : '';

        let icon, locationMeta = null;
        icon = <i className="fal fa-map-marker-alt"></i>;
        let ti = {tabIndex: 0};

        const handleOnKeyDown = (event) => {
            // 'Enter' keycode
            if ([13].includes(event.keyCode)){
                this.mapsSelector();
            }
        }

        locationMeta = (
            <div className="profileMetaDetails" onClick={() => this.mapsSelector()} {...ti} onKeyDown={handleOnKeyDown} role="link">
                <div className={`profileMetaField eventLocation ${clickableClass}`}>
                    {this.props.location[0] ? this.props.location[0].title : this.props.event.location_title_legacy}
                </div>
                <div className={`profileMetaSubField clickable ${clickableClass}`}>
                    {this.props.location[0] ? this.props.location[0].address : this.props.event.country}
                </div>
            </div>
        );

        return (
            <div className="row profileMetaFieldContainer">
                <GeckoCol width="12">
                    <div className="profileMetaIcon">
                        {icon}
                    </div>
                    {locationMeta}
                </GeckoCol>
            </div>
        );
    }

    renderQRCode() {
        if (RsvpService.isOnline(this.props.event) || this.props.event.checkin_start !== null) return null;
        return (
            <div className="d-flex flex-row justify-content-center">
                <div className="d-flex qrContainer">
                    <ProfileQr src={this.props.contact.qr_url}></ProfileQr>
                </div>
            </div>
        );
    }

    openTicketModal() {
        return new GeckoModalService().open(() => {
            return (
                <GeckoModal name="Your ticket">
                    <ProfileQr src={this.props.contact.qr_url}></ProfileQr>
                </GeckoModal>
            );
        });
    }

    renderViewTicketButton() {
        if (RsvpService.isOnline(this.props.event) || this.props.event.checkin_start === null) return null;

        return (
            <div className="row justify-content-center mt-2">
                <div className="col-12">
                    <GeckoBtn 
                        className="gecko-ui-btn btn-secondary btn"
                        name={__(STR_KEY.PROFILE_BTN_VIEW_TICKET)}
                        icon="user-check"
                        handler={() => this.openTicketModal()}
                    />
                </div>
            </div>
        );
    }

    render() {
        let startDate   = this.props.event.start_datetime;
        let endDate     = this.props.event.end_datetime;
        const isSameDay = DateUtils.isSameDay(this.props.event.start_datetime, this.props.event.end_datetime);

        let dateStr, timeStr;
        if (this.props.event.registration_type === 10 && !isSameDay) {
            dateStr = '';
            timeStr =  `${DateUtils.dayMonthYearHourMinute(startDate)} ${__(STR_KEY.MISC_TO)} ${DateUtils.dayMonthYearHourMinute(endDate)}`
        } else if (!isSameDay) {
            dateStr = `${DateUtils.dayMonthYear(startDate)} ${__(STR_KEY.MISC_TO)} ${DateUtils.dayMonthYear(endDate)}`;
            timeStr = '';
        } else {
            dateStr = `${DateUtils.dayMonthDateYear(startDate)}`;
            timeStr = `${DateUtils.hourMinute(startDate)} ${__(STR_KEY.MISC_TO)} ${DateUtils.hourMinute(endDate)}`;
        }

        // Display timezone along side time 
        timeStr = `${timeStr} (${this.props.event.timezone})`;

        return (

            <div className="profile">

                <div className="profileCard ">
                    <div className="profileCardInner z-depth-1 roundedTop">

                        {this.renderQRCode()}

                        {this.props.contact.full_name &&
                            <GeckoRow>
                                <GeckoCol width="12">
                                    <h1 className="profile-fullname text-center">
                                        {this.props.contact.full_name}
                                    </h1>
                                    {this.renderEventAttendanceStatus()}
                                </GeckoCol>
                            </GeckoRow>
                        }

                        {this.renderGuestCount()}

                    </div>

                    {this.renderSeparator()}

                    <div className="profileCardInner z-depth-1 roundedBottom profileMetaContainer">
                        <div className="row profileMetaFieldContainer">
                            <GeckoCol width="12">
                                <h2 className="profileMetaField eventTitle text-center">
                                    {this.props.event.title}
                                </h2>
                            </GeckoCol>
                        </div>

                        <div className="row profileMetaFieldContainer">
                            <GeckoCol width="12">
                                <div className="profileMetaIcon">
                                    <i className="fal fa-calendar-alt"></i>
                                </div>
                                <div className="profileMetaDetails">
                                    <div className="profileMetaField eventDate">
                                        {dateStr}
                                    </div>

                                    <div className="profileMetaSubField eventTime">
                                        {timeStr}
                                    </div>
                                </div>
                            </GeckoCol>
                        </div>

                        {this.renderDeliveryMethod()}

                        {this.renderLocation()}

                        {this.renderStatusControl()}

                        {this.renderViewTicketButton()}
                    </div>
                </div>
            </div>
        );
    }
}

Profile.contextTypes = {
    router: PropTypes.object.isRequired
};

const mapStateToProps = (store) => {
    return {
        contact: store.contact,
        eventAttendance: store.eventAttendance,
        events: store.events,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateStore: (data) => {
            dispatch(updateContact(data.contact));
            dispatch(updateEventAttendance(data.eventAttendance));
            dispatch(replaceSessions(data.sessions));
            dispatch(replaceEvents(data.events));
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Profile)